<div
  (click)="onClick()"
  class="h-auto min-h-8 px-[15px] bg-white rounded-[17px] border border-solid justify-center items-center gap-[5px] inline-flex mr-3 mb-3 cursor-pointer"
  [class.border-[#14192D]]="selected"
  [class.border-stone-300]="!selected"
  [class.border-2]="selected"
  [class.bg-[#f2f2f0]]="selected"
>
  <div *ngIf="iconUrl" class="w-4 h-4 justify-center items-center flex">
    <img [src]="iconUrl" alt="" />
  </div>
  <div
    class="text-sm font-medium leading-[14px]"
    [class.text-black]="selected"
    [class.text-[#565761]]="!selected"
  >
  {{ showHash ? '#' : '' }}{{ title }}
  </div>
</div>
